export default __webpack_public_path__ + "static/media/biography.1fa345c9.png";